import { IDatePicker } from '@common/types/element';
import React, { FC, useEffect, useMemo, useState } from 'react';
import { Platform, Text, TouchableOpacity } from 'react-native';
import { dateConfig, dateTimeConfig } from './helps/config';
import createStyles, { errorStyles } from './style';

import moment from 'moment';
import DateTimePickerApp from 'react-native-modal-datetime-picker';
import connectorInput from '../ConnectorInput';
import { OPTIONS_MODEL } from './helps/func';
const DatePickerWeb = require('react-mobile-datepicker');
const DatePickerCustom: any = DateTimePickerApp;

const DatePicker: FC<IDatePicker> = (props) => {
  const PlatformWeb = Platform.OS === 'web';
  const { changeInput, valueInput, defaultDateFormat, data, inputError } =
    props;
  const defaultValue = useMemo(() => {
    return valueInput ?? data?.defaultDateValue;
  }, [valueInput, data?.defaultDateValue]);

  const styles = createStyles(props);
  const minuteStep =
    defaultDateFormat === 'date' ? Number(props.minuteStep) || 1 : 1;

  const convertDate = (params: any) => {
    if (!params) {
      return;
    }
    if (defaultDateFormat === 'dateOnly') {
      return moment(params).format(OPTIONS_MODEL[defaultDateFormat]);
    } else if (defaultDateFormat === 'dateTextInput') {
      return moment(params).format(OPTIONS_MODEL[defaultDateFormat]);
    } else {
      return moment(params).format(OPTIONS_MODEL[defaultDateFormat]);
    }
  };

  const [visible, setVisible] = useState(false);

  const handleShowPicker = () => setVisible(true);
  const handleHidePicker = () => setVisible(false);

  const handleConfirm = (date: any) => {
    changeInput(new Date(date).toISOString());
    handleHidePicker();
  };

  // use custom date time config
  const customDateTimeConfig = {
    ...dateTimeConfig,
    minute: {
      ...dateTimeConfig.minute,
      step: minuteStep,
    },
  };

  // round minute to minute step
  const defaultTimeValue: Date = useMemo(() => {
    const currentDate = defaultValue ? new Date(defaultValue) : new Date();
    const defaultMinuteValue =
      Math.round(moment(currentDate).minutes() / minuteStep) * minuteStep;
    return moment(currentDate)
      .minutes(defaultMinuteValue)
      .startOf('minutes')
      .toDate();
  }, [defaultValue]);

  useEffect(() => {
    if (defaultDateFormat === 'date') {
      const currentDate = defaultValue ? new Date(defaultValue) : new Date();
      const defaultMinuteValue =
        Math.round(moment(currentDate).minutes() / minuteStep) * minuteStep;
      if (defaultMinuteValue !== moment(currentDate).minutes()) {
        handleConfirm(
          moment(currentDate)
            .minutes(defaultMinuteValue)
            .startOf('minutes')
            .toDate()
        );
      }
    }
  }, [defaultValue]);

  return (
    <React.Fragment>
      <TouchableOpacity
        activeOpacity={1}
        style={[styles.container, inputError ? errorStyles.errorWrapper : {}]}
        onPress={handleShowPicker}
      >
        <Text style={styles.text} numberOfLines={1}>
          {convertDate(defaultValue)}
        </Text>

        {PlatformWeb ? (
          <DatePickerWeb
            value={defaultTimeValue}
            min={new Date(1900, 0, 0)}
            max={new Date(2500, 0, 0)}
            isOpen={visible}
            onSelect={handleConfirm}
            onCancel={handleHidePicker}
            confirmText={'OK'}
            cancelText={'Cancel'}
            theme={'ios'}
            style={{ color: props.color }}
            dateConfig={
              defaultDateFormat === 'date' ? customDateTimeConfig : dateConfig
            }
          />
        ) : (
          <DatePickerCustom
            isVisible={visible}
            mode={defaultDateFormat === 'date' ? 'datetime' : 'date'}
            minimumDate={new Date(1900, 0, 0)}
            maximumDate={new Date(2500, 0, 0)}
            onConfirm={handleConfirm}
            onCancel={handleHidePicker}
            display={Platform.OS === 'ios' ? 'inline' : 'default'}
            cancelTextIOS="キャンセル"
            confirmTextIOS="OK"
          />
        )}
      </TouchableOpacity>
      {inputError ? (
        <Text style={[errorStyles.errorMessage]}>{inputError}</Text>
      ) : null}
    </React.Fragment>
  );
};

export default connectorInput(DatePicker);
